import TypesAssetsConsidered from "./TypesAssetsConsidered";

export default TypesAssetsConsidered;
